import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/badkamer-wijzer/src/app/ConditionalCookieBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Fraunces\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\"],\"style\":[\"normal\",\"italic\"],\"variable\":\"--font-fraunces\",\"display\":\"swap\"}],\"variableName\":\"fraunces\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/badkamer-wijzer/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/brochure-ui/src/components/ActieVoorwaardenLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/Adv3DBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/AdvisorCTA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/AppointmentBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/brochure-ui/src/components/AttributionCapture.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/BadkamersBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/BeforeAfter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/BrochureBarBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/BrochureForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/ExitIntentPopup.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/HeroBrochureAanvraag.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/KortingBarBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/PostcodeCheckBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/RegioBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/StappenPlanBlock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/brochure-ui/src/components/TransformationBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/brochure-ui/src/components/WebVitalsTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BeforeAfterVoorNa"] */ "/vercel/path0/packages/brochure-ui/src/components/zwaluw/BeforeAfterVoorNa.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HansKazanPopup"] */ "/vercel/path0/packages/brochure-ui/src/components/zwaluw/HansKazanPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/packages/brochure-ui/src/components/zwaluw/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WerkwijzeTimeline"] */ "/vercel/path0/packages/brochure-ui/src/components/zwaluw/WerkwijzeTimeline.tsx");
